import { HttpService } from '@/infra/http'
import type { TCores } from '@/types/cores'
import type { TProdutoStatusEnum, TProdutoTipoLegendaStatusEnum } from '@/types/produto'

export type TLote = {
  id: string
  idExterno: number
  descricao: string
  valor: number
  status: TProdutoStatusEnum
  altaProcura: boolean
  tipoLegendaStatus: TProdutoTipoLegendaStatusEnum
  coordenadas: Array<{
    latitude: number
    longitude: number
  }>
  cor: TCores
}

export type TGetLotesEmpreendimentoResponse = Array<{
  quadra: string
  lotes: TLote[]
}>

export class GetLotesEmpreendimentoService extends HttpService {
  execute = async (idExternoEmpreendimento: string) => {
    return this.http.get<TGetLotesEmpreendimentoResponse>(
      `/api/v2/Produto/empreendimento/${idExternoEmpreendimento}/lotes`,
    )
  }
}
